import { render } from "./customerConnectedChannel.vue?vue&type=template&id=2d855b2b&scoped=true"
import script from "./customerConnectedChannel.vue?vue&type=script&lang=js"
export * from "./customerConnectedChannel.vue?vue&type=script&lang=js"

import "./customerConnectedChannel.vue?vue&type=style&index=0&id=2d855b2b&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2d855b2b"]])

export default __exports__